import ApiService from "./api.service";

const main = "getInfo";
const expertise = "expertise";
export default {
    getList({ type, params, legalAidId, orderBaseId, year, search, status }) {
        return ApiService.post(
            `${main}/ownOrder?type=${type || ""}&legalAidId=${
                legalAidId || ""
            }&orderBaseId=${orderBaseId || ""}&year=${year || ""}&search=${
                search || ""
            }&status=${status || ""}`,
            params
        );
    },
    LegalAidList() {
        return ApiService.post(`${main}/directoryLegalAidList`, {
            page: 0,
            limit: 100,
        });
    },
    listOwnLegalAidType() {
        return ApiService.get(`${main}/listOwnLegalAidType`);
    },
    getEIjroParentOrgsGroupedByTypeList(data) {
        return ApiService.post(`eijro/get-parent-orgs-grouped-by-type`, data);
    },
    mailGetRegions() {
        return ApiService.get(`mail/getRegions`);
    },
    sedoContragentListAllParent(payload) {
        return ApiService.post(`sedoContragent/listAllParent`, payload);
    },
    sedoContragentGetByParentId(id) {
        return ApiService.get(`sedoContragent/getByParentId/${id}`);
    },
    mailGetArea(id) {
        return ApiService.get(`mail/getArea/${id}`);
    },
    getEIjroChildOrgList(data) {
        return ApiService.post(`eijro/child-org-list`, data);
    },
    orderBaseList() {
        return ApiService.post(`${main}/orderBaseList?search=`, {
            page: 0,
            limit: 100,
        });
    },
    create({
               file,
               params,
               legalAidId,
               personPnfl,
               orderBaseId,
               approvedDate,
               contractDate,
               contragentInn,
               contragentName,
               personLastName,
               orderRegNumber,
               personFirstName,
               personParentName,
           }) {
        let form = new FormData();
        form.append("file", file);
        params = JSON.stringify(params);
        form.append("key", params);
        personPnfl && form.append("personPnfl", personPnfl);
        contragentInn && form.append("contragentInn", contragentInn);
        contragentName && form.append("contragentName", contragentName);
        personLastName && form.append("personLastName", personLastName);
        personFirstName && form.append("personFirstName", personFirstName);
        personParentName && form.append("personParentName", personParentName);
        return ApiService.post(
            `${main}/orderCreate?${contractDate ? '&contractDate='+contractDate : ''}
            ${legalAidId ? '&legalAidId='+legalAidId : ''}${orderRegNumber ? '&orderRegNumber='+orderRegNumber : ''}
            ${orderBaseId ? '&orderBaseId='+orderBaseId : ''}${approvedDate ? '&approvedDate='+approvedDate : ''}`,
            form
        );
    },
    infoFromMvd(body) {
        return ApiService.post(`${main}/infoFromMvd`, body);
    },
    fileDownload(body) {
        return ApiService.post(`getInfo/fileDownload`, body);
    },
    getByOrderIdAndLawyerPnfl(orderId) {
        return ApiService.get(
            `${main}/getByOrderIdAndLawyerPnfl?orderId=${orderId}`
        );
    },
    ownCriminalCaseNumberList(orderId) {
        return ApiService.get(
            `${main}/ownCriminalCaseNumberList?orderId=${orderId}`
        );
    },
    listByCriminalCaseNumber(orderId, criminalCaseNumber) {
        return ApiService.get(
            `${main}/listByCriminalCaseNumber?orderId=${orderId}&criminalCaseNumber=${criminalCaseNumber}`
        );
    },
    searchCriminal(body) {
        return ApiService.post(`getInfo/searchCriminal`, body);
    },
    viewPdf(body) {
        return ApiService.post(`convert/view-pdf`, body);
    },
    mergePdfFiles(body) {
        return ApiService.post(`pdfFiles/mergePdfFiles`, body);
    },
    pdfFilesGet(letterId) {
        return ApiService.get(`pdfFiles/getByLetterId/${letterId}`);
    },
    pdfFilesUpdate(letterId) {
        return ApiService.put(`letter/updateByLetterId/${letterId}`);
    },
    pdfFilesCreate(body) {
        return ApiService.post(`pdfFiles/create`, body);
    },
    pdfFilesDeleteById(fileId) {
        return ApiService.delete(`pdfFiles/deleteById/${fileId}`);
    },
    additionalList({pagination, search, orderId}) {
        return ApiService.post(
            `additional/list?orderId=${orderId}&search=${search}`,
            pagination
        );
    },
    additionalCreate(body) {
        return ApiService.post(`additional/create`, body);
    },
    additionalFilesCreate(body) {
        return ApiService.post(`additionalFiles/create`, body);
    },
    additionalUpdate(comment, additionalId) {
        return ApiService.post(
            `additional/update?comment=${comment}&additionalId=${additionalId}`
        );
    },
    additionalDelete(fileId) {
        return ApiService.delete(`additional/delete/${fileId}`);
    },
    additionalFilesDelete(fileId) {
        return ApiService.delete(`additionalFiles/delete/${fileId}`);
    },
    cancelOrder(orderId) {
        return ApiService.post(`${main}/cancelOrder?orderId=${orderId || ""}`);
    },
    orderCount() {
        return ApiService.get(`${main}/orderCount`);
    },
    countEmployee() {
        return ApiService.get(`${main}/countEmployee`);
    },
    getListForRequest() {
        return ApiService.get(`${main}/listForRequest`);
    },
    createDraft({
                    id,
                    legalAidId,
                    personPnfl,
                    orderBaseId,
                    contractDate,
                    contragentInn,
                    orderRegNumber,
                    contragentName,
                    personLastName,
                    personFirstName,
                    personParentName,
                }) {
        if (id) {
            return ApiService.post(`${main}/updateDraft`, {
                id,
                ...(legalAidId && { legalAidId }),
                ...(personPnfl && { personPnfl }),
                ...(orderBaseId && { orderBaseId }),
                ...(contractDate && { contractDate }),
                ...(contragentInn && { contragentInn }),
                ...(orderRegNumber && { orderRegNumber }),
                ...(contragentName && { contragentName }),
                ...(personLastName && { personLastName }),
                ...(personFirstName && { personFirstName }),
                ...(personParentName && { personParentName }),
            });
        } else {
            return ApiService.post(
                `${main}/createDraft`,
            undefined,
                {
                    params: {
                        personFirstName: personFirstName || undefined,
                        legalAidId: legalAidId || undefined,
                        orderRegNumber: orderRegNumber || undefined,
                        contragentInn: contragentInn || undefined,
                        personPnfl: personPnfl || undefined,
                        contragentName: contragentName || undefined,
                        personLastName: personLastName || undefined,
                        personParentName: personParentName || undefined,
                        orderBaseId: orderBaseId || undefined,
                        contractDate: contractDate || undefined,
                    }
                }
            );
        }
    },
    deleteDraft(orderId) {
        return ApiService.post(`${main}/deleteOrder?orderId=${orderId || ""}`);
    },
    getDtoByOrderId(orderId) {
        return ApiService.get(`${main}/dtoByOrderId?orderId=${orderId || ""}`);
    },
    getDtoByOrderIdForCheck(orderId) {
        return ApiService.get(
            `${main}/dtoByOrderIdForCheck?orderId=${orderId || ""}`
        );
    },
    getByOrderId(orderId) {
        return ApiService.post(`${main}/getByOrderId?orderId=${orderId || ""}`);
    },
    getByOrderIdExpertise(orderId) {
        return ApiService.get(`${expertise}/by-order?orderId=${orderId || ""}`);
    },
    // Contragent orderlarini ko'rish
    getContragentOrder({
                           type,
                           params,
                           legalAidId,
                           orderBaseId,
                           employeePnfl,
                           year,
                           search,
                       }) {
        return ApiService.post(
            `${main}/employeeOrder?type=${type || ""}&legalAidId=${
                legalAidId || ""
            }&orderBaseId=${orderBaseId || ""}&search=${search || ""}&year=${
                year || ""
            }&employeePnfl=${employeePnfl || ""}`,
            params
        );
    },
    signatureDraft({params, orderId}) {
        return ApiService.post(
            `${main}/signatureDraft?orderId=${orderId || ""}`,
            params
        );
    },
    orderAccess({id, orderCheck, orderReason}) {
        return ApiService.post(
            `${main}/orderAccess?lawyerId=${id || ""}&orderCheck=${orderCheck}`,
            {orderReason}
        );
    },
    orderCreateCheck() {
        return ApiService.get(`${main}/orderCreateCheck`);
    },
    getExpertiseList(pagination) {
        return ApiService.post(`${expertise}/list-own?page=${pagination.page}&size=${pagination.size}`,{})
    },
    getExpertiseManualsOrganizations() {
        return ApiService.get(`${expertise}/manuals/organizations`)
    },
    getExpertiseTypes() {
        return ApiService.get(`${expertise}/manuals/enterprise-types`)
    },
    getOrganizations(regionId) {
        return ApiService.get(`${expertise}/manuals/departments?regionId=${regionId}`)
    },
    getResearchTypes(organizationId) {
        return ApiService.get(`${expertise}/manuals/research-types?departmentId=${organizationId}`)
    },
    createExpertise(data){
        return ApiService.post(`${expertise}/create`,data)
    },
    getExpertise(id){
        return ApiService.get(`${expertise}/${id}`)
    },
    getResearchMessages(id){
        return ApiService.get(`${expertise}/actions-by-research?researchId=${id}`)
    },
    sendMessage(data){
        return ApiService.post(`${expertise}/petition/answer`,data)
    },
    getPaymentDetail(id){
        return ApiService.get(`${expertise}/get-invois/${id}`)
    },
};
